// extracted by mini-css-extract-plugin
export default {"root":"ThreeFour_root__JSA65","title":"ThreeFour_title__2kQ8N","link":"ThreeFour_link__930UE","image":"ThreeFour_image__2Wj0m"};